export const INIT = 'app/INIT';
export const VISIBILITY_CHANGE = 'app/VISIBILITY_CHANGE';
export const SERVICE_UNAVAILABLE = 'app/SERVICE_UNAVAILABLE';
export const STORAGE_STATUS = 'app/STORAGE_STATUS';

export const init = () => ({
  type: INIT
});

export const visibilityChange = (hidden) => ({
  type: VISIBILITY_CHANGE,
  hidden
});

export const serviceUnavailable = () => ({
  type: SERVICE_UNAVAILABLE
});

export const storageStatus = (available) => ({
  type: STORAGE_STATUS,
  available
});
